import {
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { CustomFormContext } from "../../CustomForm";
import { prepareContent } from "../../helpers";
import { ErrorInfo, Validation } from "../../types";
import { FieldTypeId } from "../../../../lib/enums";

interface CustomNumberInputProps {
  validations?: Validation[];
  fieldId: number;
  alias: string;
  header: string;
  typeId: FieldTypeId;
  readOnlyField?: boolean;
  disabled?: boolean;
  localized?: boolean;
  required?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const CustomNumberInput = ({
  fieldId,
  alias,
  header,
  typeId,
  readOnlyField = false,
  disabled = false,
  localized = false,
  required = false,
  className = "",
  style = {},
}: CustomNumberInputProps) => {
  const {
    getValidationErrors,
    setDataDispatch,
    dataIsSet,
    errorsAreSet,
    readOnlyState,
    fieldValue,
    tempData,
    showErrors,
  } = useContext(CustomFormContext);
  const [value, setValue] = useState<string | undefined>(undefined as any);
  const [errors, setErrors] = useState<ErrorInfo[] | null>(
    getValidationErrors(alias)
  );

  useEffect(() => {
    if (!dataIsSet || !errorsAreSet) {
      return;
    }
    const data = fieldValue(alias);
    if (data === undefined) {
      return;
    }
    const errors = getValidationErrors(alias);
    setValue(data);
    if (errors) {
      setErrors(errors);
    }
  }, [dataIsSet, errorsAreSet, tempData]);

  const handleSave = () => {
    const data = prepareContent(value, alias);
    setDataDispatch({ type: "UPDATE_CONTENT", payload: data });
  };

  useEffect(() => {
    handleSave();
  }, [value]);

  useEffect(() => {
    setErrors(getValidationErrors(alias));
  }, [getValidationErrors, alias]);

  return (
    <Grid item xs={12} sm={6} lg={4} className={className} style={style}>
      <InputLabel htmlFor={alias}>
        {header}{" "}
        {(required || errors?.find((a) => a.error === "isNotNullOrEmpty")) &&
          "*"}{" "}
      </InputLabel>
      <FormControl style={{ width: "100%" }}>
        <TextField
          value={value || ""}
          disabled={readOnlyField || readOnlyState}
          required={required}
          error={errors && errors.length > 0 ? true : false}
          onChange={(e) => {
            e.preventDefault();
            const inputValue = e.target.value;
            if (!inputValue.startsWith("0")) {
              setValue(inputValue);
            } else {
              setValue("");
            }
          }}
          type={"number"}
        />
      </FormControl>
      {showErrors &&
        errors?.map((info, index) => (
          <FormHelperText key={index} variant="standard">
            <Typography variant="caption" color="red">
              {info.message}
            </Typography>
          </FormHelperText>
        ))}
    </Grid>
  );
};

CustomNumberInput.fieldType = "CustomNumberInput";

export default CustomNumberInput;
